import React, { memo } from 'react';
import { StoryblokNode } from '../../../interfaces/StoryblokNode.interface';
import SocialLink, {
  SocialLinkProps,
} from '../../SocialLink/SocialLink.component';

export interface FooterSocialLinksProps {
  links: StoryblokNode<SocialLinkProps>[];
}

const FooterSocialLinks: React.FC<FooterSocialLinksProps> = ({ links }) => {
  return (
    <ul className="flex flex-wrap items-start justify-start gap-4">
      {links.map((link: StoryblokNode<SocialLinkProps>) => (
        <SocialLink key={link.id} {...link?.content} />
      ))}
    </ul>
  );
};

FooterSocialLinks.defaultProps = {
  links: [],
};

export default memo(FooterSocialLinks);
